// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"styles-module__messageContainer___1oPBd","checkInbox":"styles-module__checkInbox___lA1Yh"};